/*!
 * @author ressourcenmangel an der Panke GmbH <adp@ressourcenmangel.de>
 */

 // Shims
import '../../utils/shims';
import '../../utils/query';
import '../../utils/cookie';

// Shared components
import '../../shared/anchor-scroll';
import '../../shared/dropdown';
import '../../shared/form-reset';
import '../../shared/popup';
import '../../shared/print';
import '../../shared/table-of-contents';

// Components
import '../../../components/atoms/link/link';
import '../../../components/atoms/table/table';

import '../../../components/organisms/form-search/form-search';
import '../../../components/organisms/gallery/gallery';
import '../../../components/organisms/header/header';
import '../../../components/organisms/hero-slider/hero-slider';
import '../../../components/organisms/glossary/glossary';

import '../../../components/molecules/accordion/accordion';
import '../../../components/molecules/carousel/carousel';
import '../../../components/molecules/figure/figure';
import '../../../components/molecules/search-input/search-input';



// WEBPACK FOOTER //
// ./src/javascripts/themes/nqz/app.js